<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Užsakymo atmetimas</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2">
          <v-card-text class="mb-0 pb-0">
            <v-row>
              <v-col cols="12">
                <el-textarea
                  required
                  :readonly="readonlyPriezastis"
                  label="Atmetimo priežastis"
                  tooltip="Paieška. Atmetimo priežastis"
                  :counter="1000"
                  v-model="priezastis"
                />
              </v-col>
            </v-row>

            <modal-paieska-atmetimas-bylos
              v-if="showBylos && showModal"
              :pai-id="paiId"
              @stopLoading="stopLoadingBylos"
            />

            <template v-if="openSign">
              <modal-sign
                :paieska-id="paiId"
                :open-sign="openSign"
                :unsigned-bylos="unsignedBylos"
                @signDone="signDone"
              />
            </template>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native.stop="closeModal()" v-if="showAtsauktiButton">
          {{ atsauktiText }}
        </el-button>
        <el-button primary @click.native.stop="submit()" v-if="canSubmit">
          {{ submitText }}
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ModalPaieskaAtmetimasBylos from './ModalPaieskaAtmetimasBylos'
import ModalSign from './ModalSign'

export default {
  name: 'ModalPaieskaAtmetimas',
  components: { ModalPaieskaAtmetimasBylos, ModalSign },
  props: {
    value: Boolean,
    paiId: Number,
    isSign: Boolean,
  },
  data() {
    return {
      loading: true,
      loadingBylos: false,
      priezastis: null,
      savedPriezastis: false,
      openSign: false,
      unsignedBylos: [],
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    readonlyPriezastis() {
      return this.savedPriezastis || this.isSigning
    },
    showBylos() {
      return this.savedPriezastis || this.isSigning
    },
    submitText() {
      return this.needSign ? 'Pasirašyti' : 'Tęsti'
    },
    atsauktiText() {
      return 'Uždaryti'
    },
    canSubmit() {
      return (!this.loadingBylos || !this.showBylos) && !this.openSign
    },
    needSign() {
      return (
        (this.savedPriezastis || this.isSigning) &&
        this.unsignedBylos.length > 0
      )
    },
    isSigning() {
      return this.isSign
    },
    allSigned() {
      return this.unsignedBylos.length === 0
    },
    showAtsauktiButton() {
      return !(this.savedPriezastis || this.isSigning) || !this.allSigned
    },
  },
  created() {
    if (this.showModal) {
      this.getStatus()
    }
  },
  methods: {
    getStatus() {
      this.loading = true

      this.$axios
        .get(`paieska/${this.paiId}/atmesti/status`)
        .then(res => {
          this.priezastis = res.data.priezastis
          this.savedPriezastis = false
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    savePriezastis() {
      this.$validator.validateAll().then(res => {
        if (!res) {
          window._VMA.$emit('FORMAT_ERROR')
          return
        }

        const data = {
          pai_atmetimo_priezastis: this.priezastis,
        }
        this.$axios
          .post(`paieska/${this.paiId}/atmesti/priezastis`, data)
          .then(res => {
            this.savedPriezastis = true
          })
          .catch(err => {
            window._VMA.$emit('DATA_ERROR', err.response.data.message)
          })
      })
    },
    saveAtmetimas() {
      this.$emit('savedData', this.paiId)
    },
    stopLoadingBylos(unsignedBylos) {
      this.unsignedBylos = unsignedBylos
      this.loadingBylos = false
    },
    closeModal() {
      if (this.isSigning) {
        this.$router.go()
      }
      this.showModal = false
    },
    submit() {
      if (this.needSign) {
        this.submitSign()
        return
      }

      if (this.isSigning && this.allSigned) {
        this.saveAtmetimas()
        return
      }

      this.savePriezastis()
    },
    cancel() {
      this.closeModal()
    },
    submitSign() {
      if (this.isSigning) {
        this.openSign = true
      } else {
        this.$store.dispatch('signBusena', 'atmetimas')
        this.$store.dispatch('signType', null).then((this.openSign = true))
      }
    },
    signDone() {
      //
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
